/**
 * ToolbarGroup Component
 *
 * Wraps StatsWidget and a toolbar so they render as one connected element
 * with shared borders, rounded corners, and shadows.
 */

import React from "react";
import PropTypes from "prop-types";
import "./ToolbarGroup.scss";

const ToolbarGroup = ({ children, className = "" }) => {
  return <div className={`toolbar-group ${className}`}>{children}</div>;
};

ToolbarGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ToolbarGroup;
